import { put, take, fork } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { reset } from 'redux-form';
import { takeLatest } from 'redux-saga';

import * as actions from 'actions';
import * as api from 'api';

export function* watchForUserUpdate() {
  while(true) { // eslint-disable-line no-constant-condition
    const action = yield take(actions.USER_UPDATE_SUCCESS);

    if (action.updates) {
      if(action.updates.avatar) {
        yield put(push('/settings'));
      }
      else if(action.updates.passWord) {
        yield put(actions.infoShow('success', action.successMessage));
        yield put(reset('userSettings'));
      }
    }
  }
}

export default function* backgroundSaga(socket, request) {
  yield [
    fork(takeLatest, actions.USER_UPDATE, request(api.userUpdate, 'updates')),
    fork(takeLatest, actions.USER_AVATARS_FETCH, request(api.userAvatarsFetch, 'avatars')),
    fork(watchForUserUpdate)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/user/sagas.js
 **/